import { forwardRef, ReactElement } from 'react';
import Tippy from '@tippyjs/react';
import { Placement } from 'tippy.js';

type TippyChildrenProps = {
  children: ReactElement;
};

const TippyChildren = forwardRef<HTMLDivElement, TippyChildrenProps>((props, ref) => {
  return <div ref={ref}>{props.children}</div>;
});

export const FloatableButton = (props: {
  children: ReactElement;
  floating?: boolean;
  tippy?: boolean;
  attention?: boolean;
  tippyContent?: ReactElement | string;
  tippyPlacement?: string;
}) => {

  const {
    floating = false,
    tippy = false,
    attention = false,
    tippyContent,
    tippyPlacement = 'bottom',
  } = props;

  const buttonClasses = [];

  if (floating) {
    buttonClasses.push('floating-button');
  }

  if (attention) {
    buttonClasses.push('gets-attention');
  }

  const placement = tippyPlacement as Placement;

  return (
    <span className={buttonClasses.join(' ')}>
      <Tippy content={tippyContent} className="inline-block" visible={tippy} placement={placement}>
        <TippyChildren>{props.children}</TippyChildren>
      </Tippy>
    </span>
  );
};
